import React, { lazy } from 'react';
import PermissionService from '@Services/PermissionService';
const Client = lazy(() => import('./components/Client'));

export const clientConfig = [
	{
		auth: true,
		component: <Client />,
		name: 'client',
		path: '/client/:id',
		pm: (pm) => PermissionService(pm).canAccessClientDetails(),
	},
]